import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { PDFDocument } from 'pdf-lib'
import { from, Observable } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

@Injectable()
export class PdfService {
  constructor(private http: HttpClient) {}

  countPagesInPdf(link: string): Observable<number> {
    return this.http.get(link, { responseType: 'arraybuffer' }).pipe(
      switchMap((arrayBuffer: ArrayBuffer) =>
        from(PDFDocument.load(arrayBuffer)).pipe(map((pdfDoc) => pdfDoc.getPageCount())),
      ),
      catchError((error) => {
        throw error
      }),
    )
  }
}
